<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="
          $t('global.projectreporting') + ' (' + projekterfassungenCount + ')'
        "
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success mr-2"
              @click="neueProjekterfassung"
              v-if="editable"
            >
              <font-awesome-icon icon="fa-regular fa-plus" class="mr-2" />
              {{ $t("global.newprojectreporting") }}
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="editable"
            >
              <font-awesome-icon class="mr-1" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <div>
              <b-table
                ref="selectableTable"
                tbody-tr-class="item"
                style="max-height: 300px"
                responsive
                sticky-header
                :items="projekterfassungen"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="isBusy"
                show-empty
                sort-icon-left
                selectable
                select-mode="range"
              >
                <template v-slot:head(selected)="row">
                  <b-form-checkbox
                    v-model="row.selected"
                    @input="selectAllRows(row)"
                  ></b-form-checkbox>
                </template>

                <template v-slot:cell(selected)="row">
                  <b-form-checkbox
                    v-model="row.item.selected"
                    @input="onRowSelected(row)"
                  ></b-form-checkbox>
                </template>

                <template #cell(edit)="row" class="d-flex align-items-center">
                  <div
                    class="ml-5"
                    role="button"
                    @click="projekterfassungBearbeiten(row.item)"
                  >
                    <font-awesome-icon icon="fa-regular fa-pencil" size="sm" />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #empty>
                  <div v-if="ladeFehler" class="text-center text-danger my-2">
                    <strong>{{ $t("global.errorwhileloading") }}</strong>
                  </div>
                  <div v-if="!ladeFehler" class="text-center text-primary my-2">
                    <strong>{{ $t("global.nodataavailable") }}</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <projekterfassung-modal
      @abbrechen="getProjekterfassungen"
      :rapportierteStunden="rapportierteStunden"
      :arbeitszeit="arbeitszeit"
      @uebernehmeProjekt="projekterfassungUebernehmen"
    />

    <loeschen-modal
      id="projekterfassung-loeschen-modal"
      @confirmed="projekterfassungLoeschen"
      :selectedIds="selectedIds"
    />
  </div>
</template>

<script>
import Api from "@/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";

import LoeschenModal from "@/components/Modals/LoeschenModal";
import ProjekterfassungModal from "@/components/Modals/ProjekterfassungModal.vue";

import reiter from "@/mixins/Reiter";

export default {
  name: "Projekterfassungsliste",
  components: {
    ContainerHeadline,
    LoeschenModal,
    BSpinner,
    ProjekterfassungModal,
  },
  mixins: [reiter],
  props: {
    timesheet: {
      type: String,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    arbeitszeit: {
      type: Number,
      required: true,
    },
    rapportierteStunden: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 200,
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      projekterfassungen: [],
      projekterfassungenCount: 0,
      aktuelleRapportierteStunden: 0,
      fields: [
        { key: "selected", label: "" },
        {
          key: "projektaufgabe.projekt.endkunde.name",
          sortable: true,
          label: this.$t("dashboard.customer"),
        },
        {
          key: "projektaufgabe.projekt.bezeichnung",
          sortable: true,
          label: this.$t("dashboard.project"),
        },
        {
          key: "projektaufgabe.bezeichnung",
          sortable: true,
          label: this.$t("dashboard.projecttask"),
        },
        {
          key: "stunden",
          sortable: true,
          label: this.$t("dashboard.hours"),
        },
        { key: "edit", sortable: false, label: this.$t("dashboard.edit") },
      ],
      selected: [],
      selectedIds: [],
    };
  },
  watch: {
    shown(val) {
      if (val && this.projekterfassungen.length == 0)
        this.getProjekterfassungen();
    },
    aktuelleRapportierteStunden(val) {
      this.$emit("updateRapportierteStunden", val);
    },
  },
  computed: {
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  mounted() {
    if (this.shown && this.projekterfassungen.length == 0)
      this.getProjekterfassungen();

    this.setHeaders("dashboard", [
      "",
      "customer",
      "project",
      "projecttask",
      "hours",
      "edit",
    ]);
  },
  created() {},
  methods: {
    projekterfassungBearbeiten(projekterfassung) {
      let thisErfassung = {
        stunden: projekterfassung.stunden,
        timesheet: this.timesheet,
        id: projekterfassung.id,
        projekt: projekterfassung.projektaufgabe.projekt,
        projektaufgabe: projekterfassung.projektaufgabe,
        bemerkung: projekterfassung.bemerkung,
        arbeitszeit: this.arbeitszeit,
        rapportierteStunden: this.rapportierteStunden,
      };

      this.$bus.$emit("projekterfassung-modal", {
        projekterfassung: thisErfassung,
        timesheet: this.timesheet,
      });
    },

    getProjekterfassungen() {
      this.isBusy = true;

      Api.get("zeiterfassung/projekterfassung/", {
        params: {
          ts: this.timesheet,
          type: 2,
          page: this.page,
          count: this.anzahlProPage,
        },
      })
        .then((response) => {
          this.projekterfassungen = response.data;
          this.getAktuelleRapportierteStunden();
          this.projekterfassungenCount = this.projekterfassungen.length;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    neueProjekterfassung() {
      this.$bus.$emit("projekterfassung-modal", { timesheet: this.timesheet });
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "projekterfassung-loeschen-modal");
      else {
        this.$notify({
          type: "warn",
          title: this.$t("notification.actionfailed"),
          text: this.$t("notification.noregistrationselecteddeletion"),
        });
      }
    },

    projekterfassungUebernehmen(json) {
      if (json.id) {
        Api.put("zeiterfassung/projekterfassung/", json, {
          params: { id: json.id },
        }).then(() => {
          this.getProjekterfassungen();
        });
      } else {
        Api.post("zeiterfassung/projekterfassung/", json).then(() => {
          this.getProjekterfassungen();
        });
      }
    },

    projekterfassungLoeschen() {
      this.isBusy = true;

      Api.delete("zeiterfassung/projekterfassung/", {
        params: { ids: this.selectedIds.join(",") },
      }).then(() => {
        this.getProjekterfassungen();
      });
    },

    getAktuelleRapportierteStunden() {
      let sum = 0;
      this.projekterfassungen.forEach((erfassung) => {
        sum += erfassung.stunden;
      });
      this.aktuelleRapportierteStunden = sum;
    },
  },
};
</script>
